import React from "react"
import { Link } from "gatsby"
import BlogPaginationStyle from "./BlogListPaginationStyle.module.styl"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons/faAngleLeft"
import { faAngleRight } from "@fortawesome/free-solid-svg-icons/faAngleRight"

const BlogPagination = ({ currentPage, numberOfPages }) => {
  const isFirst = currentPage === 1
  const isLast = currentPage === numberOfPages
  const previousPage =
    currentPage - 1 === 1 ? "/blog/" : "/blog/" + (currentPage - 1).toString()
  const nextPage = "/blog/" + (currentPage + 1).toString()

  return (
    <div className={BlogPaginationStyle.pagination}>
      {isFirst ? (
        <div className={BlogPaginationStyle.previous_page_disabled}>
          <FontAwesomeIcon icon={faAngleLeft} />
        </div>
      ) : (
        <Link to={previousPage} className={BlogPaginationStyle.previous_page}>
          <FontAwesomeIcon icon={faAngleLeft} />
        </Link>
      )}
      {Array.from({ length: numberOfPages }, (_, i) =>
        currentPage === i + 1 ? (
          <Link
            className={
              currentPage
                ? BlogPaginationStyle.active_page
                : BlogPaginationStyle.current_page
            }
            key={i}
            to={currentPage === 1 ? "/blog" : ""}
          >
            {i + 1}
          </Link>
        ) : (
          <Link
            className={BlogPaginationStyle.current_page}
            key={i}
            to={i + 1 === 1 ? "/blog" : `/blog/${i + 1}`}
          >
            {i + 1}
          </Link>
        )
      )}

      {isLast ? (
        <div className={BlogPaginationStyle.next_page_disabled}>
          <FontAwesomeIcon icon={faAngleRight} />
        </div>
      ) : (
        <Link to={nextPage} className={BlogPaginationStyle.next_page}>
          <FontAwesomeIcon icon={faAngleRight} />
        </Link>
      )}
    </div>
  )
}

export default BlogPagination
